import React, { useState } from 'react';
import { motion } from 'framer-motion';
import toast from 'react-hot-toast';
import { authAPI } from '../services/api';
import '../styles/admin.css';

const AdminAuth = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (field, value) => {
    setCredentials(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Simple hardcoded authentication - no API required
    if (credentials.username === 'admin' && credentials.password === 'admin123') {
      // Store auth data in localStorage
      const userData = {
        id: 1,
        username: 'admin',
        email: 'admin@truehome.com',
        fullName: 'Admin User',
        role: 'admin'
      };
      
      localStorage.setItem('truehome_token', 'demo-token-' + Date.now());
      localStorage.setItem('truehome_user', JSON.stringify(userData));
      localStorage.setItem('truehome_admin_auth', 'true');
      
      toast.success(`Welcome back, ${userData.username}!`);
      onLogin(userData);
    } else {
      toast.error('Invalid credentials. Use admin/admin123');
    }
    
    setIsLoading(false);
  };

  const handleDemoLogin = () => {
    setCredentials({
      username: 'admin',
      password: 'admin123'
    });
    toast('Demo credentials loaded. Click Sign In to continue.', {
      icon: 'ℹ️',
    });
  };

  return (
    <div className="admin-auth">
      <div className="auth-container">
        <motion.div
          className="auth-card"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="auth-header">
            <div className="auth-logo">
              <h2>TrueHome<span className="accent">Admin</span></h2>
            </div>
            <h3>Admin Login</h3>
            <p>Access your luxury real estate dashboard</p>
          </div>

          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Username</label>
              <div className="input-wrapper">
                <i className="fas fa-user"></i>
                <input
                  type="text"
                  placeholder="Enter username"
                  value={credentials.username}
                  onChange={(e) => handleInputChange('username', e.target.value)}
                  required
                  autoComplete="username"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Password</label>
              <div className="input-wrapper">
                <i className="fas fa-lock"></i>
                <input
                  type="password"
                  placeholder="Enter password"
                  value={credentials.password}
                  onChange={(e) => handleInputChange('password', e.target.value)}
                  required
                  autoComplete="current-password"
                />
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-primary auth-btn"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <div className="loading"></div>
                  <span>Signing In...</span>
                </>
              ) : (
                <>
                  <span>Sign In</span>
                  <i className="fas fa-arrow-right"></i>
                </>
              )}
            </button>
          </form>

          <div className="auth-demo">
            <div className="demo-divider">
              <span>Demo Access</span>
            </div>
            <button
              type="button"
              className="btn btn-secondary demo-btn"
              onClick={handleDemoLogin}
              disabled={isLoading}
            >
              <i className="fas fa-eye"></i>
              <span>Use Demo Credentials</span>
            </button>
            <div className="demo-info">
              <p><strong>Username:</strong> admin</p>
              <p><strong>Password:</strong> admin123</p>
              <p style={{ fontSize: '0.85rem', color: '#6b7280', marginTop: '10px' }}>
                <i className="fas fa-info-circle"></i> Run <code>npm run db:create-admin</code> to create this user
              </p>
            </div>
          </div>

          <div className="auth-footer">
            <p>© 2024 TrueHome Properties. All rights reserved.</p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default AdminAuth;